import React from 'react'
import Button from './index'
import { Icon } from 'packages/eid-icons'

const styles = {
    normal: {
        minWidth: '145px',
        backgroundColor: '#01ae8f',
        color: '#ffffff',
        zIndex:'1',
        '&:hover': {
            boxShadow: '0 2px 8px 0 rgba(1, 174, 143, 0.33)',
            backgroundColor: '#01ae8f',
            color: '#ffffff',
            '& svg': {
                color: '#ffffff',
            },
        },
        '&:active': {
            backgroundColor: '#01ae8f',
            color: '#ffffff',
            '& svg': {
                color: '#ffffff',
            },
            boxShadow:
                '0 2px 8px 0 rgba(1, 174, 143, 0.33), inset 2px 2px 4px 0 rgba(0, 0, 0, 0.11)',
        },
    },
    disabled: {
        backgroundColor: '#aab0b4 !important',
        color: '#ffffff !important',
    },
}

const ApproveButton = (props) => {
    return (
        <Button
            size="large"
            style={styles.normal}
            disabledStyles={styles.disabled}
            startIcon={<Icon name="Approve" color="#ffffff" />}
            {...props}
        />
    )
}

export default ApproveButton
